import React from 'react'
import styles from './Card.module.css'

export default function Card({ children, padding = 'md', className = '', ...rest }) {
  const classes = [styles.card, styles[padding], className].filter(Boolean).join(' ')
  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  )
}
